export default __webpack_public_path__ + "static/media/solana-sonata.0f08575d.png";